class RegistrationPopup {
  constructor() {
    this.popup = document.getElementById('registration-discount-popup');
    this.notification = document.getElementById('popup-notification');
    this.isInitialized = false;
    this.WEBHOOK_URL = 'https://office.ampriomilano.com/forms/discount-submit';
    this.SHOW_DELAY = 5000;
    this.popupShown = false;
    this.timers = { main: null };
    this.observers = { mutation: null, resize: null };
    this.cartCheckInterval = null;
    this.init();
  }

  init() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    
    // Сначала только критичные операции
    this.setupEventListeners();
    this.checkDiscountUrl();
    this.checkSavedDiscountCode();
    
    // Откладываем тяжелые операции
    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        this.setupObservers();
        // this.checkAndShowPopup(); // Отключено автоматическое появление поп-апа при загрузке страницы
      }, { timeout: 3000 });
    } else {
      setTimeout(() => {
        this.setupObservers();
        // this.checkAndShowPopup(); // Отключено автоматическое появление поп-апа при загрузке страницы
      }, 2000);
    }
  }

  setupEventListeners() {
    const handlers = {
      '#notification-close': () => this.hideNotification(),
      '.registration-popup__close-btn': () => this.handlePopupClose(),
      '.registration-popup__overlay': () => this.handlePopupOverlayClose(),
      '#done-btn': () => this.handleDone()
    };

    Object.entries(handlers).forEach(([selector, handler]) => {
      const el = this.popup?.querySelector(selector) || document.querySelector(selector);
      if (el) el.addEventListener('click', handler);
    });

    if (this.notification) {
      this.notification.addEventListener('click', (e) => {
        if (e.target.id === 'notification-close' || e.target.closest('.popup-notification__close')) {
          e.preventDefault();
          e.stopPropagation();
          this.hideNotification();
        } else {
          this.openPopupFromNotification();
        }
      });
    }

    const form = document.getElementById('registration-form');
    if (form) form.addEventListener('submit', (e) => this.handleFormSubmit(e));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup?.classList.contains('show')) this.hidePopup();
    });

    window.addEventListener('beforeunload', () => this.cleanup());
    this.setupScrollEvents();
  }

  setupObservers() {
    const cartIndicatorFixed = document.querySelector('.cart-indicator-fixed');
    if (!cartIndicatorFixed) return;

    this.observers.mutation = new MutationObserver(() => {
      clearTimeout(this.cartCheckTimeout);
      this.cartCheckTimeout = setTimeout(() => this.updateNotificationPosition(), 100);
    });

    this.observers.mutation.observe(cartIndicatorFixed, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    if (window.ResizeObserver) {
      this.observers.resize = new ResizeObserver(() => {
        clearTimeout(this.cartCheckTimeout);
        this.cartCheckTimeout = setTimeout(() => this.updateNotificationPosition(), 100);
      });
      this.observers.resize.observe(cartIndicatorFixed);
    }

    this.cartCheckInterval = setInterval(() => {
      if (this.notification?.style.display !== 'none' && window.innerWidth > 768) {
        this.updateNotificationPosition();
      }
    }, 500);
  }

  updateNotificationPosition() {
    if (!this.notification || this.notification.style.display === 'none' || window.innerWidth <= 768) return;

    const cartIndicatorFixed = document.querySelector('.cart-indicator-fixed');
    const isVisible = cartIndicatorFixed && window.getComputedStyle(cartIndicatorFixed).display !== 'none';
    this.notification.style.setProperty('bottom', isVisible ? '96px' : '20px', 'important');
  }

  checkAndShowPopup() {
    if (this.hasExistingDiscount() || !this.isHomePage()) return;
    this.startAutoPopupTimer();
  }

  hasExistingDiscount() {
    return localStorage.getItem('popup_subscribed') === 'true' || 
           this.getCookie('discount_code') !== null || 
           localStorage.getItem('discount_code') !== null;
  }


  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop().split(';').shift() : null;
  }

  markAsSubscribed() {
    localStorage.setItem('popup_subscribed', 'true');
    this.hideNotification();
  }

  checkDiscountUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount');
    
    if (discountCode) {
      this.applyDiscountCode(discountCode);
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('discount');
      window.history.replaceState({}, '', newUrl.toString());
    }
  }

  checkSavedDiscountCode() {
    if (window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout')) {
      const savedDiscountCode = localStorage.getItem('discount_code') || this.getCookie('discount_code');
      if (savedDiscountCode) {
        setTimeout(() => this.applyDiscountToCart(savedDiscountCode), 2000);
      }
    }
  }

  applyDiscountCode(code) {
    document.cookie = `discount_code=${code}; path=/; max-age=31536000`;
    localStorage.setItem('discount_code', code);
    this.trackPopupEvent('discount_applied_from_url', 'auto');
    this.applyDiscountToCart(code);
    this.showDiscountAppliedMessage(code);
  }

  async applyDiscountToCart(code) {
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const cartDiscountComponent = document.querySelector('cart-discount-component');
      if (!cartDiscountComponent) {
        await this.applyDiscountDirectly(code);
        return;
      }

      const sectionId = cartDiscountComponent.dataset?.sectionId;
      if (!sectionId) {
        await this.applyDiscountDirectly(code);
        return;
      }

      const existingDiscounts = this.getExistingDiscounts(cartDiscountComponent);
      if (existingDiscounts.includes(code)) return;

      const config = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          discount: [...existingDiscounts, code].join(','),
          sections: [sectionId]
        })
      };

      const response = await fetch(Theme.routes.cart_update_url, config);
      const data = await response.json();

      const discountApplied = data.discount_codes?.find(d => d.code === code && d.applicable === true);

      if (discountApplied && data.sections?.[sectionId]) {
        const parsedHtml = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
        const section = parsedHtml.getElementById(`shopify-section-${sectionId}`);
        const currentSection = document.getElementById(`shopify-section-${sectionId}`);
        if (section && currentSection) currentSection.innerHTML = section.innerHTML;
      } else {
        await this.applyDiscountDirectly(code);
      }
    } catch (error) {
      await this.applyDiscountDirectly(code);
    }
  }

  async applyDiscountDirectly(code) {
    try {
      const cartSections = document.querySelectorAll('[id*="shopify-section-"][id*="cart"]');
      if (cartSections.length === 0) return;

      const sectionId = cartSections[0].id.replace('shopify-section-', '');
      const config = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code, sections: [sectionId] })
      };

      const response = await fetch(Theme.routes.cart_update_url, config);
      const data = await response.json();

      if (data.discount_codes?.find(d => d.code === code && d.applicable === true)) {
        window.location.reload();
      } else {
        this.applyDiscountViaForm(code);
      }
    } catch (error) {
      return;
    }
  }

  applyDiscountViaForm(code) {
    try {
      const discountInput = document.querySelector('#cart-discount, input[name="discount"]');
      if (!discountInput) return;

      const discountForm = discountInput.closest('form');
      if (!discountForm) return;

      discountInput.value = code;
      discountInput.dispatchEvent(new Event('input', { bubbles: true }));
      discountForm.dispatchEvent(new Event('submit', { bubbles: true }));
    } catch (error) {
      return;
    }
  }

  getExistingDiscounts(cartDiscountComponent) {
    const discountCodes = [];
    const discountPills = cartDiscountComponent.querySelectorAll('.cart-discount__pill');
    discountPills.forEach(pill => {
      if (pill instanceof HTMLLIElement && pill.dataset?.discountCode) {
        discountCodes.push(pill.dataset.discountCode);
      }
    });
    return discountCodes;
  }

  showDiscountAppliedMessage(code) {
    const notification = document.createElement('div');
    notification.className = 'unified-notification';
    notification.style.cssText = `position:fixed;top:20px;right:20px;background:#fff;border:1px solid #e0e0e0;border-radius:7px;box-shadow:0 4px 12px rgba(0,0,0,0.15);padding:16px;z-index:10000;max-width:320px;opacity:0;transform:translateX(100%);transition:all 0.3s ease;font-family:'Cabinet Grotesk',sans-serif`;
    
    notification.innerHTML = `<div style="display:flex;align-items:center;gap:12px"><div style="width:40px;height:40px;display:flex;align-items:center;justify-content:center"><img src="/assets/cupon.svg" alt="Coupon" style="width:24px;height:24px"></div><div style="flex:1"><h4 style="margin:0 0 4px 0;font-size:14px;font-weight:500;color:#3F4443;text-transform:uppercase">DISCOUNT APPLIED</h4><p style="margin:0;font-size:13px;color:#3F4443;text-transform:uppercase">Code: ${code}</p></div></div>`;
    
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.style.opacity = '1';
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => notification.remove(), 300);
    }, 5000);
  }

  isHomePage() {
    return window.location.pathname === '/' || window.location.pathname === '/index';
  }

  startAutoPopupTimer() {
    if (this.timers.main) clearTimeout(this.timers.main);
    this.timers.main = setTimeout(() => {
      if (!this.hasExistingDiscount() && !this.popupShown && this.isHomePage()) {
        this.showPopup();
      }
    }, this.SHOW_DELAY);
  }

  setupScrollEvents() {
    let scrollTimeout = null;
    
    window.addEventListener('scroll', () => {
      if (this.notification?.style.display !== 'none') {
        this.notification.style.setProperty('opacity', '0.5', 'important');
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (this.notification?.style.display !== 'none') {
            this.notification.style.setProperty('opacity', '1', 'important');
          }
        }, 150);
      }
    }, { passive: true });
    
    if (this.notification) {
      this.notification.addEventListener('mouseenter', () => {
        if (this.notification?.style.display !== 'none') {
          this.notification.style.setProperty('opacity', '1', 'important');
          if (scrollTimeout) clearTimeout(scrollTimeout);
        }
      });
    }
  }

  hideNotification() {
    if (!this.notification) return;
    localStorage.setItem('popup_notification_hidden_until', 'true');
    setTimeout(() => localStorage.removeItem('popup_notification_hidden_until'), 600000);
    this.notification.classList.remove('show');
    this.notification.style.setProperty('display', 'none', 'important');
    this.notification.style.removeProperty('opacity');
    this.notification.style.removeProperty('visibility');
    this.notification.style.removeProperty('z-index');
  }

  showPopup() {
    if (this.popupShown || !this.popup) return;

    // Временно отключаем блокировку скролла от amprio-header
    if (typeof window.temporarilyDisableScrollBlock === 'function') {
      window.temporarilyDisableScrollBlock();
    }

    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.popup.style.display = 'flex';
    document.body.classList.add('popup-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    
    setTimeout(() => this.popup.classList.add('show'), 10);
    this.popupShown = true;
    this.setupPopupButtons();
    sessionStorage.setItem('registrationPopupLastShown', Date.now().toString());
    this.trackPopupEvent('popup_show', 'first_stage');
  }

  hidePopup() {
    if (!this.popup) return;
    
    this.popup.classList.remove('show');
    document.body.classList.remove('popup-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.width = '';
    
    if (this.scrollPosition !== undefined) {
      window.scrollTo(0, this.scrollPosition);
      this.scrollPosition = undefined;
    }
    
    setTimeout(() => {
      this.popup.style.display = 'none';
      this.popupShown = false;
      
      // Восстанавливаем блокировку скролла от amprio-header если нужно
      if (typeof window.restoreScrollBlock === 'function') {
        window.restoreScrollBlock();
      }
    }, 300);
  }

  setupPopupButtons() {
    const closeButton = document.getElementById('close-button');
    if (closeButton) closeButton.style.display = 'block';
  }

  openPopupFromNotification() {
    if (!this.popup) return;
    if (this.hasExistingDiscount()) {
      this.hideNotification();
      return;
    }
    this.hideNotification();
    this.showPopup();
  }

  handlePopupClose() {
    this.trackPopupEvent('popup_close', 'first_stage');
    this.hidePopup();
  }
  
  handlePopupOverlayClose() {
    this.trackPopupEvent('popup_overlay_close', 'first_stage');
    this.hidePopup();
  }

  handleDone() {
    this.trackPopupEvent('popup_done', 'success_stage');
    this.hidePopup();
  }

  handleFormSubmit(e) {
    e.preventDefault();
    
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    
    const submitBtn = form.querySelector('.registration-popup__submit-btn');
    const formData = new FormData(form);
    
    const contactData = {
      firstName: formData.get('firstName')?.toString() || '',
      email: formData.get('email')?.toString().toLowerCase().trim() || '',
      timestamp: new Date().toISOString(),
      source: 'discount_popup'
    };
    
    if (!contactData.firstName || !contactData.email) {
      this.showFormError('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(contactData.email)) {
      this.showFormError('Please enter a valid email address');
      return;
    }
    
    this.submitRegistration(contactData, submitBtn);
  }

  showFormError(message) {
    const errorBlock = document.getElementById('form-error');
    const errorText = errorBlock?.querySelector('.registration-popup__error-text');
    
    if (errorBlock && errorText) {
      errorText.textContent = message;
      errorBlock.style.display = 'block';
      setTimeout(() => errorBlock.style.display = 'none', 5000);
    }
  }

  async submitRegistration(contactData, submitBtn) {
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing...';
    }

    this.trackPopupEvent('form_submit_success', 'first_stage');
    this.markAsSubscribed();
    this.showSuccessState(contactData.firstName);
    this.sendDataInBackground(contactData, submitBtn);
  }

  async sendDataInBackground(contactData, submitBtn) {
    try {
      fetch(this.WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contactData)
      }).catch(() => {});
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Unlock Access';
      }
    }
  }

  showSuccessState(firstName) {
    const registrationState = this.popup?.querySelector('[data-state="registration"]');
    const successState = this.popup?.querySelector('[data-state="success"]');
    const userNameElement = this.popup?.querySelector('.registration-popup__user-name');
    
    if (registrationState) registrationState.style.display = 'none';
    if (successState) successState.style.display = 'flex';
    if (userNameElement) userNameElement.textContent = firstName ? firstName.trim() : 'User';
  }

  openEmailClient() {
    this.trackPopupEvent('check_mail_click', 'second_stage');
    window.location.href = 'mailto:';
    setTimeout(() => this.hidePopup(), 1000);
  }

  trackPopupEvent(action, stage) {
    if (typeof ym !== 'undefined') ym(104111919, 'reachGoal', `${action}_${stage}`);
    if (typeof gtag !== 'undefined') gtag('event', action, { event_category: 'popup_discount', event_label: stage, value: 1 });
    if (typeof ga !== 'undefined') ga('send', 'event', 'popup_discount', action, stage);
  }

  cleanup() {
    Object.values(this.timers).forEach(timer => {
      if (timer) clearTimeout(timer);
    });
    
    if (this.cartCheckTimeout) clearTimeout(this.cartCheckTimeout);
    if (this.cartCheckInterval) clearInterval(this.cartCheckInterval);
    if (this.observers.mutation) this.observers.mutation.disconnect();
    if (this.observers.resize) this.observers.resize.disconnect();
  }
}

function initPopup() {
  const popup = document.getElementById('registration-discount-popup');
  const notification = document.getElementById('popup-notification');
  
  if (!popup || !notification) {
    setTimeout(initPopup, 100);
    return;
  }
  
  window.registrationPopupInstance = new RegistrationPopup();
}

// Отложенная инициализация - не блокируем загрузку страницы
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // Откладываем инициализацию до полной загрузки страницы
    if (window.requestIdleCallback) {
      requestIdleCallback(() => initPopup(), { timeout: 2000 });
    } else {
      setTimeout(() => initPopup(), 1000);
    }
  });
} else {
  // Откладываем инициализацию если страница уже загружена
  if (window.requestIdleCallback) {
    requestIdleCallback(() => initPopup(), { timeout: 2000 });
  } else {
    setTimeout(() => initPopup(), 1000);
  }
}

window.openRegistrationPopup = function() {
  // Временно отключаем блокировку скролла от amprio-header
  if (typeof window.temporarilyDisableScrollBlock === 'function') {
    window.temporarilyDisableScrollBlock();
  }
  
  if (window.registrationPopupInstance) {
    window.registrationPopupInstance.showPopup();
  } else {
    const popup = document.getElementById('registration-discount-popup');
    if (popup) {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      popup.style.display = 'flex';
      document.body.classList.add('popup-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      setTimeout(() => popup.classList.add('show'), 10);
    }
  }
};